// Fn autocomplete

var fn_input_autocomplete = function () {

    var targetInput = $('.ui-autocomplete-input');

    if (!targetInput) {
        // The node we need does not exist yet.
        // Waiting 500ms and try again
        window.setTimeout(fn_input_autocomplete, 500);
        return;
    }

    if (typeof $(targetInput).autocomplete !== "function") {
        return;
    }

    $(targetInput).autocomplete({
        open: function (event, ui) {
            $(event.target).addClass("ui-autocomplete-dropdown");
        },
        close: function (event, ui) {
            $(event.target).removeClass("ui-autocomplete-dropdown");
        }
    });


};
